import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = ({ downloadLink, ToastContainer, subscribeToNewsletters, notify }) => {
  return (
    <div className='overflow-x-hidden'>
      <Helmet>
            <title>Vent Africa - Your Crypto ATM</title>

            <meta name="description" content="Crypto to Cash Made Easy, Convert your crypto to Cash, Instant Payment, Zero Charge, Download Vent App" />
            <meta name="keywords" content="Crypto, Cash, Bitcoin, BTC, Fiat, Naira, USD, Ethereum, OTC, Trade" />
      </Helmet>
      <Header downloadLink={downloadLink} />
      <ToastContainer />

      {/* Hero Section */}
      <section className="relative pt-36 lg:pt-48 bg-gradient-to-t to-[#f6fcff] from-[#cef0ff]">
        <div className="max-w-[1500px] mx-auto px-5 xl:px-16 flex flex-col lg:flex-row justify-between">

          <div className="w-full lg:w-3/12">
            <p className="tracking-[.2rem] text-sm font-light text-[#05364D] mb-4">CRYPTO-TO-CASH MADE EASY</p>
            <p className="text-4xl leading-tight text-[#05364D] mb-10">THE RE-IMAGINED CRYPTO ATM THAT NEVER RUNS OUT OF
              <span><img src="img/Frame 3915.png" alt="" className="max-w-[180px] inline" /></span>
            </p>

            <a href={downloadLink} target='_blank' rel="noopener noreferrer" className="inline-flex mb-8 items-center gap-2 px-8 py-4 bg-[#2CB8F2] rounded-sm text-white z-50 text-xs md:text-xs lg:text-md">
              <img src="img/Frame.png" alt="" />
              Download on iOS or Android
              <img src="img/Frame (1).png" alt="" />
            </a>
            
            <div className="hidden lg:block">
              <p className="text-sm leading-loose font-light text-[#05364d] mb-6">We’ve built a reputable off-ramp platform that makes crypto-to-cash transactions more straightforward, effortless, and secure than ever.</p>
              <img src="img/line-7.png" alt="" className="w-full" />
            </div>
          </div>

          <div className="w-full lg:w-6/12 flex lg:pl-[90px] justify-center">
            <img src="img/mockuuups-female-hand-holding-iphone-14-pro-mockup 1.png" className="hidden lg:block" alt="" />
          </div>

          <div className="flex flex-col gap-10 mt-5">
            <div className="flex flex-col gap-10 mb-20 sm:mb-5 lg:mb-0 relative">
              <div>
                <img src="img/Frame 56.png" alt="" className="max-w-[50px]" />
                <p className="text-2xl text-[#05364D]">145K+</p>
                <p className="text-[#05364D] text-base">Completed Payouts.</p>
              </div>
              <div>
                <img src="img/Frame 56 (1).png" alt="" className="max-w-[50px]" />
                <p className="text-2xl text-[#05364D]">10K+</p>
                <p className="text-[#05364D] text-base">Total Users.</p>
              </div>
              <div>
                <img src="img/Frame 56 (2).png" alt="" className="max-w-[50px]" />
                <p className="text-2xl text-[#05364D]">$50M+</p>
                <p className="text-[#05364D] text-base">Trading Volume.</p>
              </div>
              <img src="img/mockuuups-female-hand-holding-iphone-14-pro-mockup 1 (1).png"
                className="absolute right-[-10px] mr-[-0.6rem] top-0 block lg:hidden max-w-[200px] sm:max-w-[300px]" alt="" />
            </div>

            <div className="flex justify-center sm:justify-start">
              <img src="img/Add-on.png" alt="" className="max-w-[350px]" />
            </div>

            <div className="block lg:hidden mb-14 pr-5">
              <p className="text-base text-[#05364d] mb-6">We’ve built a reputable off-ramp platform that makes crypto-to-cash transactions more straightforward, effortless, and secure than ever.</p>
              <img src="img/line-7.png" alt="" className="w-full" />
            </div>
          </div>
        </div>
      </section>

      {/* Ads Section */}
      <section className="pt-28">
        <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-7">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img src="img/Rectangle 549.png" width="700" alt="" />
            </div>
            <div className="w-full lg:w-1/3">
              <div className="flex justify-center lg:block">
                <img src="img/Coin Dropsheet.png" alt=""
                  className="w-[330px] sm:w-[370px] lg:w-[370px] mt-[-4rem] lg:mt-0 lg:ml-[-8rem] mb-6" />
              </div>
              <div>
                <p className="text-3xl sm:text-3xl lg:text-4xl max-w-[400px] text-[#05364D] mb-4">QUICK PAYOUTS, <br /> NO HASSLES. </p>
                <p className="text-base font-light leading-6 text-[#05364D]">Say goodbye to stress, risks and exorbitant fees. With our quick payouts, the best rates and no fees, crypto-to-cash transactions have never been better.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Offering Section */}
      <section className="pt-24">
        <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
          <div className="flex justify-center">
            <p className="text-[#05364D] text-sm mb-6 px-5 py-3 tracking-tight rounded-full border border-gray-100">OUR OFFERINGS
            </p>
          </div>
          <div className="text-center lg:max-w-[700px] mx-auto mb-14">
            <p className="text-xl sm:text-3xl lg:text-4xl  text-[#05364D] uppercase">WE HAVE EVERYTHING YOU'RE LOOKING FOR AND MORE . . .</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
            <div className="col-span-1 lg:col-span-2 h-full">
              <div className="flex flex-col bg-gray-100 h-full">
                <div className="w-full">
                  <img width="450" height="450"
                    src="img/mockuuups-iphone-13-pro-mockup-perspective-left-floating-shadow 1.png" alt=""
                    className="object-cover" />
                </div>
                <div className="w-full flex flex-col justify-center items-center text-center px-10 pb-3">
                  <p className="text-2xl mb-4 text-[#05364D] capitalize">Track Your Withdrawals</p>
                  <p className="mb-4 font-light text-[#05364D]">Seamlessly track and monitor your withdrawals every step of the way. Stay informed and empowered as you manage your financial transactions effortlessly.</p>
                </div>
              </div>
            </div>

            <div className="col-span-1 lg:col-span-3 h-full">
              <div className="flex flex-col bg-gray-100 pt-6 px-10 h-full">
                <div className="w-full flex flex-col justify-center items-center text-center">
                  <h1 className="text-2xl mt-4 max-w-[400px] mx-auto text-[#05364D] capitalize">Trade your crypto assets with ease</h1>
                  <p className="mt-4 max-w-[600px] mx-auto font-light text-[#05364D]">Our platform supports more than two cutting-edge cryptocurrencies, with Bitcoin and USDT leading the way. Effortlessly exchange your crypto assets for cash at the best rates with no fees charged. Experience the future of trading today!</p>
                </div>
                <div className="w-full text-center">
                  <img width="655" height="655" src="img/image 17.png" alt=""
                    className="object-cover inline" />
                </div>
              </div>
            </div>

            <div className="col-span-1 lg:col-span-3 h-full">
              <div className="flex flex-col bg-gray-100 pb-6 pt-10 px-10 h-full">
                <div className="w-full flex flex-col justify-center items-center text-center">
                  <h1 className="text-2xl mt-4 max-w-[500px] mx-auto text-[#05364D] capitalize">24/7 Customer Support</h1>
                  <p className="mt-4 mb-4 max-w-[620px] font-light mx-auto text-[#05364D]">Getting stranded is a myth over here. YOUR friends on our support team are available round the clock to assist you whenever you need guidance or have any concerns. You can trade confidently, rest assured that help is just a message away whenever you need it.</p>
                </div>

                <div className="hidden lg:flex items-center justify-center">
                  <img src="img/Rectangle 244.png" alt="" className="object-cover" />
                </div>
                <div className="flex items-center justify-center lg:hidden">
                  <img src="img/Rectangle 255.png" alt="" className="" />
                </div>
              </div>
            </div>

            <div className="col-span-1 lg:col-span-2 h-full">
              <div className="flex flex-col bg-gray-100 pt-10 h-full">
                <div className="w-full flex flex-col justify-center items-center text-center px-10">
                  <h1 className="text-2xl mt-4 max-w-[500px] mx-auto text-[#05364D] capitalize">Beautifully crafted Guide to
                    get you started with your trades.</h1>
                  <p className="mt-4 mb-4 max-w-[620px] font-light mx-auto text-[#05364D]">
                    In addition to an incredibly intuitive user-interface, we've got a beautifully crafted guide to get you started. Embark on your trading journey with confidence and finesse with our carefully crafted trading guide seamlessly introducing you to the world of trading.
                  </p>
                </div>
                <div className="w-full">
                  <img src="img/mockuuups-iphone-13-pro-mockup-isometric-floor-right 1.png" alt=""
                    className="object-cover" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-24">
        <div className="max-w-[1500px] mx-auto px-5 lg:px-16">
          <div className="flex justify-center">
            <p className="text-[#05364D] text-sm tracking-tight mb-5 px-5 py-3 rounded-full border border-gray-100">TESTIMONIALS
            </p>
          </div>
          <div className="text-center lg:max-w-[700px] mx-auto mb-14">
            <p className="text-2xl sm:text-3xl lg:text-4xl  text-[#05364D] uppercase">OUR PLATFORM IS TESTED AND TRUSTED. HERE'S WHAT OUR USERS ARE SAYING</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-7 lg:grid-cols-7 xl:grid-cols-9 gap-5">
            <div className="col-span-1 sm:col-span-3 lg:col-span-3 xl:col-span-2 flex flex-col gap-5">
              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Bethel Kelvin</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Google Playstore</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">The best crypto trading app I have come across so far, fast and smooth. Its payment is very secure. Kudos to the admin.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Magba Esther</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Google Playstore</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">So far, they are still the best. I havent't had any issues using the app.</p>
                </div>
              </div>
            </div>

            <div className="col-span-1 sm:col-span-4 lg:col-span-4 xl:col-span-4 flex flex-col gap-5">
              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Elpresh</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Apple Store</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">This is the easiest crypto liquidating app have seen so far. From account set up to their style of trading, even their payment method is something to praise…..I applaud you guys for good job…in liquidating crypto asset you guys are the best in Africa I’ve seen so far, can’t wait for you guys to add more crypto currency</p>
                </div>
              </div>

              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Akinola John</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Google Playstore</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">I love the customer service, network delayed my withdrawal and I got a call explaining the delay. Nice work guys.</p>
                </div>
              </div>
            </div>

            <div className="col-span-1 sm:col-span-7 lg:col-span-7 xl:col-span-3 flex flex-col sm:flex-row lg:flex-row xl:flex-col gap-5">
              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Gudtalent Chrisent</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Google Playstore</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">Pretty fast and easy to use. Easiest way to sell my Bitcoin. (Crypto to cash) Great job here guys❤️.</p>
                </div>
              </div>

              <div className="flex items-start gap-2 p-5 h-full border border-gray-200 rounded-sm">
                {/* <img src="img/Ellipse 5.png" alt="" className="max-w-[40px]" /> */}
                <div>
                  <p className="text-sm text-[#05364D] tracking-tight font-semibold uppercase">Freedom Peters</p>
                  <p className="text-xs text-gray-400 tracking-tight uppercase mb-4">Apple Store</p>
                  <p className="text-xs font-light text-[#05364d] leading-loose">One of the best Crypto to cash platform you’ll be happy to trade with.</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      <Footer onSubscribeToNewsletters={subscribeToNewsletters} onNotify={notify} />
    </div>
  )
}

export default Home;